module.exports = __webpack_public_path__ + "static/media/ksa.f30015fc.png";